import { DateTime } from "luxon";
import {
  formatToMoney,
} from "../../../../lib/formatter";

import { hyphenSymbol, textTime } from "../VariableStatic";


export class ConferenceBookingDetailPresenter {
  constructor(bookingDetail) {
    const bookingDateList = bookingDetail.booking_date && bookingDetail.booking_date.length > 0
      ? bookingDetail.booking_date.map(
        (bookingDate, index) => {
          const breaks = bookingDate.break_option
            && bookingDate.break_option.break_times
            && bookingDate.break_option.break_times.length > 0
            ? bookingDate.break_option.break_times.map(
              (breakTime, breakIndex) => ({
                  id: breakIndex + 1,
                  time: `${breakTime}${textTime}`,
                })
            )
            : null

          const lunch = bookingDate.break_option && bookingDate.break_option.lunch_time
            ? `${bookingDate.break_option.lunch_time}${textTime}`
            : hyphenSymbol

          const breakOption = {
            breaks,
            lunch,
            packageTitle: bookingDate.break_option && bookingDate.break_option.package_title
              ? bookingDate.break_option.package_title
              : hyphenSymbol
          }

          return {
            id: index + 1,
            date: DateTime.fromISO(bookingDate.date).toFormat(
              'dd-MM-yyyy'
            ),
            timeDuration: bookingDate.time_duration,
            numberOfPeople: bookingDate.number_of_people,
            pattern: bookingDate.room_pattern,
            breakOption,
            price: bookingDate.price,
            priceText: formatToMoney(
              bookingDate.price,
              2,
              "฿"
            ),
          };
        }
      )
      : [];

    const imageConferenceRooms = bookingDetail.room_type
      && bookingDetail.room_type.images
      && bookingDetail.room_type.images.length > 0
      ? bookingDetail.room_type.images
      : [];

    const bookingDateDetail = {
      roomTypeId: bookingDetail.room_id,
      roomTitle: bookingDetail.room_type && bookingDetail.room_type.title || 'UNKNOWN',
      totalPrice: bookingDetail.total_price, //
      totalPriceText: formatToMoney(
        bookingDetail.total_price,
        2,
        "฿"
      ),
      bookingDateList,
      createdAt: DateTime.fromISO(bookingDetail.created_at).toFormat(
        `dd-MM-yyyy HH:mm${textTime}`
      ),
      imageConferenceRooms
    }

    const bookingInformation = {
      name: `${bookingDetail.first_name} ${bookingDetail.last_name}`,
      companyName: bookingDetail.company_name || hyphenSymbol,
      address: bookingDetail.address || hyphenSymbol,
      email: bookingDetail.email || hyphenSymbol,
      phoneNumber: bookingDetail.mobile || hyphenSymbol,
      eventName: bookingDetail.event_name || hyphenSymbol,
      eventDetail: bookingDetail.event_detail || hyphenSymbol,
      status: bookingDetail.status || "UNKNOWN"
    }

    this.bookingDate = bookingDateDetail || [];
    this.bookingInformation = bookingInformation
  }
}
